module.exports = "/fonts/dripicons-v2.ttf?cf09c981aeaa8736810133ab1148e4a3";